import { render, staticRenderFns } from "./BaseClockIcon.vue?vue&type=template&id=00e52a12"
import script from "./BaseClockIcon.vue?vue&type=script&lang=js"
export * from "./BaseClockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports